import axios from "axios";
import actions from "./action_types";
import mutations from "./mutation_types";
import Vue from "vue";

const canAssignPriceListToClient = (store, priceLists) => {
    let clientPriceListsAdded = store.getters.getPriceLists;
    let containPriceList = clientPriceListsAdded.some(
        clientPriceLists => clientPriceLists.id == priceLists.id
    );

    if (!containPriceList && priceLists.type == "special") {
        return true;
    } else if (!containPriceList && priceLists.type == "standard") {
        let clientPriceLists = clientPriceListsAdded.filter(value => {
            let bool = false;
            if (priceLists.date_to == null && value.date_to == null) {
                bool = true;
            } else if (
                priceLists.date_to == null &&
                value.date_to > priceLists.date_from
            ) {
                bool = true;
            } else if (
                value.date_to != null &&
                priceLists.date_from <= value.date_from &&
                priceLists.date_to >= value.date_to
            ) {
                bool = true;
            }
            return bool;
        });

        if (clientPriceLists.length == 0) {
            return true;
        }
        return false;
    }
    return false;
};

export default {
    [actions.GET_CURRENCY_NAME_SELECT]: function(store) {
        axios
            .get(
                "/customer-service/clients/get/price-lists/" +
                    store.getters.getClientId
            )
            .then(response => {
                store.commit(mutations.SET_CURRENCY_NAME_SELECT, response.data);
            })
            .catch(error => {
                console.error(error);
            });
    },

    [actions.SAVE_CLIENT_ID]: function(store, clientId) {
        store.commit(mutations.SET_CLIENT_ID, clientId);
    },

    [actions.ADD_TO_PRICE_LISTS]: function(store, priceLists) {
        priceLists.forEach(element => {
            store.commit(mutations.PUSH_TO_PRICE_LISTS, element);
        });
    },

    [actions.ADD_TO_PRICE_LISTS_BY_IDS]: function(store, priceListsIds) {
        if(priceListsIds !== undefined){
            priceListsIds.forEach(id => {
                store.dispatch(actions.FETCH_PRICE_LIST, id);
            });
        }

    },

    [actions.SAVE_CLIENT_PRICE_LISTS]: function(store, priceLists) {
        let requestData = {
            priceListId: priceLists.id,
            clientId: store.getters.getClientId
        };
        axios
            .post(
                "/customer-service/clients/set/client-price-lists",
                requestData
            )
            .then(response => {
                store.commit(
                    mutations.PUSH_TO_PRICE_LISTS,
                    response.data.priceList
                );
                toastr["info"](response.data.message).css("border", "0px");
            })
            .catch(error => {
                if (error.response.status == 406) {
                    toastr["warning"](error.response.data.message).css(
                        "border",
                        "0px"
                    );
                } else {
                    toastr["error"](error.response.data.message).css(
                        "border",
                        "0px"
                    );
                }
            });
    },

    [actions.SET_CLIENT_PRICE_LISTS]: function(store, priceLists) {
        if (canAssignPriceListToClient(store, priceLists)) {
            store.commit(mutations.PUSH_TO_PRICE_LISTS, priceLists);
            toastr["info"](
                Vue.prototype.__("successfully_added_price_lists_to_client")
            ).css("border", "0px");
        } else {
            toastr["warning"](
                Vue.prototype.__("cant_add_price_list_to_client")
            ).css("border", "0px");
        }
    },

    [actions.REMOVE_CLIENT_PRICE_LISTS]: function(store, priceList) {
        let requestData = {
            priceListId: priceList.id,
            clientId: store.getters.getClientId
        };

        axios
            .post(
                "/customer-service/clients/remove/client-price-list",
                requestData
            )
            .then(response => {
                store.commit(mutations.REMOVE__FROM_PRICE_LISTS, priceList);
                toastr["info"](response.data.message).css("border", "0px");
            })
            .catch(error => {
                toastr["error"](error.response.data.message).css(
                    "border",
                    "0px"
                );
            });
    },

    [actions.UNSET_CLIENT_PRICE_LISTS]: function(store, priceList) {
        store.commit(mutations.REMOVE__FROM_PRICE_LISTS, priceList);
        toastr["info"](
            Vue.prototype.__("successfully_deleted_price_lists_from_client")
        ).css("border", "0px");
    },

    [actions.FETCH_PRICE_LIST]: function(store, id) {
        axios
            .get("/customer-service/clients/fetch/price-list/" + id)
            .then(response => {
                store.commit(
                    mutations.PUSH_TO_PRICE_LISTS,
                    response.data.priceList
                );
            });
    },

    async [actions.CHECK_CLIENT_IS_READY](store, payload) {
        return axios.get("/customer-service/clients/check/ready/" + payload);
    },

    async [actions.GET_GUS_INFO](store, payload) {
        return axios.post("/records/contractors/getgusinfo", payload);
    },
    async [actions.GET_GUS_INFO_NOT_LOGGED](store, payload) {
        return axios.post("/gus-info", payload);
    },


    async [actions.CHECK_USER_DATA_EXIST_IN_SYSTEM](store, payload) {
        return axios.post(
            "/customer-service/clients/check-in-system/user-data-exist",
            payload
        );
    },

    async [actions.CHECK_USER_DATA_EXIST_IN_SYSTEM_AS_GUEST](store, payload) {
        return axios.post(
            "/guest/check-in-system/user-data-exist",
            payload
        );
    }
};
